import React from 'react';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import type { PayeeSourceConditionType } from 'app-components/flux/transaction-rules/transactionRulesTypes';

import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  column: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    flex: 1,
    flexWrap: 'wrap',
    '> *': {
      lineHeight: '24px',
    },
    alignContent: 'flex-start',
  },
  textPaddingAfter: {
    paddingRight: theme.spacing(0.5),
  },
  textPaddingBefore: {
    paddingLeft: theme.spacing(0.5),
  },
  token: {
    padding: '2px 4px',
    margin: '2px',
    background: theme.palette.background.default,
    border: `1px solid ${theme.palette.border.main}`,
    borderRadius: 6,
    h6: { lineHeight: '20px' },
    marginRight: 4,
  },
  inline: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
  },
  matchType: {
    alignSelf: 'center',
  },
}));

const PayeeSource: React.FC<{ payee?: PayeeSourceConditionType }> = ({ payee }) => {
  const { cx, classes } = useStyles();

  return (
    <>
      {payee && (
        <Box className={classes.column}>
          {payee.payeeMatchingCriteria?.map((criterion, index) => (
            <span className={classes.inline} key={`${criterion.payeeMatchingOperator}_${criterion.payeeName}_${index}`}>
              {index === 0 ? (
                <Typography variant='bodyRegular'>
                  {payee.payeeType === 'STATEMENT' ? 'Original statement name' : 'Quicken name'}
                </Typography>
              ) : (
                <Typography variant='bodyRegular' className={classes.textPaddingBefore}>
                  OR
                </Typography>
              )}
              <Typography
                className={cx(classes.textPaddingBefore, classes.textPaddingAfter, classes.matchType)}
                variant='bodyMedium'
              >
                {criterion.payeeMatchingOperator === 'CONTAINS' ? 'contains' : 'is exactly'}
              </Typography>
              {criterion.payeeMatchingOperator === 'CONTAINS' &&
                criterion?.payeeName
                  ?.split(' ')
                  .filter((token) => token !== '')
                  .map((token) => (
                    <Box key={token} className={classes.token}>
                      <Typography variant='bodyMedium'>{token.toLowerCase()}</Typography>
                    </Box>
                  ))}
              {criterion.payeeMatchingOperator === 'EQUALS' && (
                <Typography variant='bodyMedium'>{`"${criterion.payeeName}"`}</Typography>
              )}
            </span>
          ))}
        </Box>
      )}
    </>
  );
};

export default PayeeSource;
